export type PromptAssistanceState =
  | { key: string; phase: "suggested" }
  | {
      key: string;
      phase: "enhancing" | "preview" | "error";
      prompt: string;
      completedPrompt: string | null;
    }
  | { key: string; phase: "applied"; originalDraftKey: string; originalPrompt: string };

/** Keep the latest validated rewrite while its replacement streams. */
export function beginPromptReview(
  key: string,
  previous: PromptAssistanceState | null,
): PromptAssistanceState {
  const completedPrompt =
    previous?.key === key && "completedPrompt" in previous ? previous.completedPrompt : null;
  return {
    key,
    phase: "enhancing",
    prompt: "",
    completedPrompt,
  };
}

export function finishPromptReview(
  state: PromptAssistanceState,
  prompt: string,
): PromptAssistanceState {
  if (state.phase !== "enhancing") return state;
  return {
    ...state,
    phase: "preview",
    prompt,
    completedPrompt: prompt,
  };
}

/** Closing aborts unfinished work but keeps the last complete version available. */
export function closePromptReview(state: PromptAssistanceState): PromptAssistanceState {
  if (state.phase !== "enhancing" && state.phase !== "error") return state;
  return state.completedPrompt !== null
    ? { ...state, phase: "preview", prompt: state.completedPrompt }
    : { key: state.key, phase: "suggested" };
}
